import React, { useState, useMemo, createContext, ReactNode } from "react";

type StatusContextType = {
  pageTransactionStatus: string;
  setPageTransactionStatus: (arg1: string) => void;
};

export const StatusContext = createContext<StatusContextType>({
  pageTransactionStatus: "",
  setPageTransactionStatus: (arg1) => {},
});

const Status = ({ children }: { children: ReactNode }) => {
  const [pageTransactionStatus, setPageTransactionStatus] = useState("idle");

  const value = useMemo(
    () => ({ pageTransactionStatus, setPageTransactionStatus }),
    [pageTransactionStatus]
  );

  return (
    <StatusContext.Provider value={value}>{children}</StatusContext.Provider>
  );
};

export default Status;
